export const PRODUCT_INITIAL_VAL = {
    productNameEn: '',
    productNameAr: '',
    shortDescriptionEn: '',
    shortDescriptionAr: '',
    descriptionEn: '',
    descriptionAr: '',
    thumbnail: null,
    images: null,
}